import { Link } from "react-router-dom"

import './helpbg.css'

export default function Helpbg() {

  // console.log("Help Menu")

  return (
    <div className="helpbg" >
      <h2>Help Menu</h2>
      <br />
      <p>
      This is a shopping list website tailored for markets.  
      It has a number of features and is very quick.      
      You login with an email and your chosen password so 
      you can tailor the site to your needs.
      </p>
      
      <br />
      {/* <p>Contact info RepairDude7@gmail.com</p> */}
      <br />
      <Link className="btnYes" to="/">Login</Link>

    </div>
  )
}